import { Link } from "react-router-dom";
import { LogIn, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LOGO, ORG } from "@/data/site";

export default function AdminLogin() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const signIn = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A2540] px-6">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8 text-center">
        <img src={LOGO} alt={`${ORG.name} logo`} className="h-16 w-16 object-contain mx-auto" />
        <h1 className="mt-4 font-display font-extrabold text-2xl text-[#0A2540]">Staff Login</h1>
        <p className="mt-2 text-[#475569]">Sign in with your authorized Google account to view form submissions.</p>

        <Button onClick={signIn} data-testid="google-signin-button" className="mt-8 w-full bg-[#E85D04] hover:bg-[#CC5202] text-white font-semibold rounded-full h-12">
          <LogIn className="w-4 h-4 mr-2" /> Sign in with Google
        </Button>

        <p className="mt-6 text-xs text-[#94a3b8]">Access is restricted to approved administrators only.</p>

        <Link to="/" className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#16A34A] hover:text-[#0A2540]">
          <ArrowLeft className="w-4 h-4" /> Back to website
        </Link>
      </div>
    </div>
  );
}
